<div class="screen-fit" [formGroup]="inscripcionForm">

    <!-- HEADER SUPERIOR -->
    <div class="row inscripcion-top-header w-100 mx-auto">

        <!-- Espacio izquierdo -->
        <div class="col-2 header-side-space"></div>

        <!-- Logos centrados -->
        <div class="col-8 sponsor-logos-header">

            <div class="sponsor-logo-item" *ngIf="getLogoDefault()">
                <img [src]="getLogoDefault()" [alt]="getNombreDefault()" class="sponsor-logo-img">
            </div>

            <div class="sponsor-separator" *ngIf="showLogoCustomer()"></div>

            <div class="sponsor-logo-item" *ngIf="showLogoCustomer()">
                <img [src]="getLogoCustomer()" [alt]="getNombreCustomer()"
                    class="sponsor-logo-img sponsor-logo-customer">
            </div>

        </div>

        <!-- Mesa de ayuda derecha -->
        <div class="col-2 header-help-column">
            <a class="header-help-box" *ngIf="getTelefonoCustomer()" [href]="getTelefonoCustomerHref()"
                aria-label="Mesa de ayuda">

                <span class="header-help-icon">
                    <i class="fi fi-rr-headset"></i>
                </span>

                <span class="header-help-content">
                    <span class="header-help-label">Mesa de ayuda</span>
                    <strong class="header-help-number">{{ getTelefonoCustomer() }}</strong>
                </span>

            </a>
        </div>

    </div>


    <!-- STEPPER SUPERIOR -->
    <div class="inscripcion-stepper" *ngIf="!showSuccessExecutiveScreen">
        <div class="stepper-item" [ngClass]="{ 'active': currentStep === 1, 'completed': currentStep > 1 }" (click)="goToStep(1)">
            <div class="stepper-circle">1</div>
            <div class="stepper-label">Selección de plan</div>
        </div>

        <div class="stepper-line"></div>

        <div class="stepper-item" [ngClass]="{ 'active': currentStep === 2, 'completed': currentStep > 2 }" (click)="goToStep(2)">
            <div class="stepper-circle">2</div>
            <div class="stepper-label">Datos del titular</div>
        </div>

        <div class="stepper-line"></div>

        <div class="stepper-item" [ngClass]="{ 'active': currentStep === 3, 'completed': currentStep > 3 }" (click)="goToStep(3)">
            <div class="stepper-circle">3</div>
            <div class="stepper-label">Beneficiarios</div>
        </div>

        <div class="stepper-line"></div>

        <div class="stepper-item" [ngClass]="{ 'active': currentStep === 4, 'completed': currentStep > 4 }" (click)="goToStep(4)">
            <div class="stepper-circle">4</div>
            <div class="stepper-label">Resumen y envío</div>
        </div>
    </div>

    <!-- LOADING -->
    <div class="row mt-xl-3 mx-0" *ngIf="loading">
        <div class="col-12 p-0">
            <div class="card p-4 text-center">
                <span class="title-step">Cargando información del convenio...</span>
            </div>
        </div>
    </div>

    <ng-container *ngIf="!loading">

        <!-- CONVENIO NO DISPONIBLE -->
        <div class="row mt-xl-3 mx-0 justify-content-center" *ngIf="!convenioDisponible">
            <div class="col-12 p-0 d-flex justify-content-center">
                <div class="card unavailable-card-template">
                    <div class="unavailable-icon-wrapper">
                        <div class="unavailable-icon-circle">
                            <i class="fi fi-rr-link-slash unavailable-main-icon"></i>
                        </div>
                    </div>

                    <p class="unavailable-convenio-name">{{ getNombreConvenio() }}</p>

                    <h1 class="unavailable-title">
                        El enlace de inscripción<br>
                        no se encuentra disponible
                    </h1>

                    <p class="unavailable-description">
                        Este enlace puede estar inactivo o el convenio<br class="d-none d-md-block">
                        ya no se encuentra vigente.
                    </p>

                    <div class="unavailable-info-line">
                        <i class="fi fi-rr-info"></i>
                        <span>Por favor, contacta a AlmaMedis o al responsable de tu convenio.</span>
                    </div>

                    <div class="unavailable-contact-box">
                        <div class="unavailable-contact-title">
                            <i class="fi fi-rr-info"></i>
                            <span>Puedes llamarnos o escribirnos, estamos para ayudarte.</span>
                        </div>

                        <div class="unavailable-contact-actions">
                            <a href="mailto:soporte@almamedis.cl" class="unavailable-contact-action">
                                <i class="fi fi-rr-envelope"></i>
                                <span>soporte@almamedis.cl</span>
                            </a>

                            <a href="tel:+56200000000" class="unavailable-contact-action">
                                <i class="fi fi-rr-phone-call"></i>
                                <span>+56 2 0000 0000</span>
                            </a>
                        </div>
                    </div>

                    <button type="button" class="unavailable-primary-btn" (click)="contactarAlmamedis()">
                        Contactar a AlmaMedis
                        <i class="fi fi-rr-arrow-right ml-2"></i>
                    </button>
                </div>
            </div>
        </div>

        <!-- FORMULARIO PRINCIPAL -->
        <div class="row mt-xl-3 mx-0 justify-content-center" *ngIf="convenioDisponible && !showSuccessExecutiveScreen">
            <div class="col-12 p-0 left-col-fill">
                <div class="card h-100 p-0 card-left form-card">
                    <!-- STEP 1 -->
                    <div *ngIf="steps.seleccionPlan">

                        <div class="form-content p-3 step1-content" [formGroup]="titularForm">

                            <h3 class="m-0 title-step">Elige tu plan</h3>
                            <h5 class="m-0 sub-title-step">Selecciona el plan que deseas contratar</h5>
                            <br>

                            <div class="step1-plans-scroll">
                                <div class="plans-grid" *ngIf="planesDisponibles.length > 0">
                                    <div class="plan-select-card" *ngFor="let plan of planesDisponibles"
                                        [ngClass]="{ 'selected': esPlanSeleccionado(plan) }"
                                        (click)="seleccionarPlan(plan)">

                                        <div class="plan-select-badge">
                                            {{ plan.cus_ben_name || plan.nombre }}
                                        </div>

                                        <!-- <div class="plan-select-subtitle">
                                            {{ getPlanSubtitulo(plan) }}
                                        </div> -->

                                        <!-- <div class="plan-select-separator"></div> -->

                                        <div class="plan-select-price">
                                            {{ formatPrecioPlan(plan.cus_ben_price_titular) }}
                                        </div>

                                        <div class="plan-select-price-caption">
                                            Mensual IVA incluido
                                        </div>

                                        <div class="plan-select-features">

                                            <div class="plan-select-feature">
                                                <div class="plan-select-feature-main">
                                                    <div class="plan-select-feature-icon">
                                                        <i class="fi fi-rr-user"></i>
                                                    </div>
                                                    <span>Titular</span>
                                                </div>

                                                <strong>{{ formatPrecioPlan(plan.cus_ben_price_titular) }}</strong>
                                            </div>

                                            <div class="plan-select-feature">
                                                <div class="plan-select-feature-main">
                                                    <div class="plan-select-feature-icon">
                                                        <i class="fi fi-rr-users"></i>
                                                    </div>
                                                    <span>Beneficiario 1</span>
                                                </div>

                                                <strong>{{ formatPrecioPlan(plan.cus_ben_price_carga1) }}</strong>
                                            </div>

                                            <div class="plan-select-feature">
                                                <div class="plan-select-feature-main">
                                                    <div class="plan-select-feature-icon">
                                                        <i class="fi fi-rr-users-alt"></i>
                                                    </div>
                                                    <span>Beneficiarios adicionales</span>
                                                </div>

                                                <strong>{{ formatPrecioPlan(plan.cus_ben_price_carga2) }} c/u</strong>
                                            </div>

                                            <div class="plan-select-feature"
                                                *ngIf="getEspecialidadesPlan(plan).length > 0">
                                                <div class="plan-select-feature-main">
                                                    <div class="plan-select-feature-icon">
                                                        <i class="fi fi-rr-stethoscope"></i>
                                                    </div>
                                                    <span>{{ getEspecialidadesPlan(plan).length }}
                                                        especialidad(es)</span>
                                                </div>
                                            </div>

                                        </div>

                                        <div class="plan-specialties-preview"
                                            *ngIf="getEspecialidadesPlan(plan).length > 0">

                                            <div class="plan-specialty-chip"
                                                *ngFor="let especialidad of getEspecialidadesVisiblesPlan(plan)">
                                                {{ especialidad.spe_name }}
                                            </div>

                                            <button type="button" class="plan-specialty-chip plan-specialty-chip-more"
                                                *ngIf="getEspecialidadesOcultasCount(plan) > 0"
                                                (click)="toggleEspecialidadesPlan(plan, $event)">
                                                {{
                                                isEspecialidadesPlanExpanded(plan)
                                                ? 'Ver menos'
                                                : '+' + getEspecialidadesOcultasCount(plan)
                                                }}
                                            </button>

                                        </div>

                                        <div class="plan-select-feature plan-phone-feature">
                                            <div class="plan-select-feature-main">
                                                <div class="plan-select-feature-icon">
                                                    <i class="fi fi-rr-phone-call"></i>
                                                </div>
                                                <span>Orientación de salud telefónica 24/7</span>
                                            </div>
                                        </div>

                                        <button type="button" class="plan-select-card-button"
                                            [ngClass]="{ 'selected': esPlanSeleccionado(plan) }"
                                            (click)="seleccionarPlan(plan); $event.stopPropagation();">
                                            {{ esPlanSeleccionado(plan) ? 'Plan seleccionado' : 'Seleccionar plan' }}
                                        </button>

                                    </div>
                                </div>

                                <div class="not-hours" *ngIf="planesDisponibles.length === 0">
                                    <div class="d-flex">
                                        <i class="fi fi-rr-info d-flex align-items-center"></i>
                                        <span>No hay planes disponibles para este convenio.</span>
                                    </div>
                                </div>
                            </div>

                            <small class="text-danger d-block mt-2"
                                *ngIf="titularForm.get('plan')?.touched && titularForm.get('plan')?.invalid">
                                Debes seleccionar un plan para continuar.
                            </small>

                            <div class="form-footer col-12 mt-4 px-0 step1-footer-fixed">
                                <div class="d-flex justify-content-end align-items-center footer-actions">
                                    <button type="button" class="btn btn-secondary btn-pill"
                                        [disabled]="!isStep1Valid()" (click)="nextFromStep1()">
                                        Continuar
                                        <i class="fi fi-rr-arrow-right ml-2"></i>
                                    </button>
                                </div>
                            </div>

                        </div>

                    </div>

                    <!-- STEP 2 -->
                    <div *ngIf="steps.titular">

                        <div class="form-content px-4 py-3 step2-content" formGroupName="titular">

                            <h3 class="m-0 title-step">Datos del titular</h3>
                            <h5 class="m-0 sub-title-step">Completa los datos de inscripción del titular</h5>
                            <!-- <br> -->

                            <div class="step2-plan-summary-card" *ngIf="getPlanSeleccionado()">
                                <div class="step2-plan-top">
                                    <div>
                                        <span>Plan seleccionado</span>
                                        <strong>{{ getPlanSeleccionado()?.cus_ben_name }}</strong>
                                    </div>
                                    <button type="button" class="step2-change-plan-btn" (click)="goToStep1()">
                                        <i class="fi fi-rr-edit"></i>
                                        Cambiar plan
                                    </button>
                                </div>
                                <div class="step2-price-main">
                                    <span>Valor mensual del plan</span>
                                    <strong>{{ formatPrecioPlan(getTotalPlanMensual()) }}</strong>
                                </div>
                                <button type="button" class="step2-detail-toggle"
                                    (click)="toggleDetallePrecioTitular()">
                                    {{ mostrarDetallePrecioTitular ? 'Ocultar detalle del precio' : 'Ver detalle del
                                    precio' }}
                                    <i class="fi"
                                        [ngClass]="mostrarDetallePrecioTitular ? 'fi-rr-angle-small-up' : 'fi-rr-angle-small-down'">
                                    </i>
                                </button>

                                <div class="step2-price-detail" *ngIf="mostrarDetallePrecioTitular">

                                    <div class="step2-price-detail-row" *ngFor="let item of getDetallePrecioTitular()">
                                        <span>{{ item.label }}</span>
                                        <strong>{{ formatPrecioPlan(item.amount) }}</strong>
                                    </div>
                                    <div class="step2-price-detail-row step2-price-detail-total">
                                        <span>Total</span>
                                        <strong>{{ formatPrecioPlan(getTotalPlanMensual()) }}</strong>
                                    </div>
                                </div>

                            </div>

                            <div class="form-row">

                                <div class="form-group col-lg-12 col-xl-6">
                                    <label class="label-sm">RUT del titular*</label>

                                    <input type="text" class="form-control form-control-rounded"
                                        placeholder="Ej: 12.345.678-9" formControlName="rut"
                                        (input)="onTitularRutInput()"
                                        (blur)="onRutBlur()"
                                        (keypress)="allowOnlyRutChars($event)">

                                    <small class="text-info d-block mt-1" *ngIf="checkingTitularPlanExist">
                                        Validando RUT y plan seleccionado...
                                    </small>

                                    <small class="text-danger d-block mt-1"
                                        *ngIf="titularForm.get('rut')?.touched && titularForm.get('rut')?.hasError('required')">
                                        El RUT del titular es obligatorio.
                                    </small>

                                    <small class="text-danger d-block mt-1"
                                        *ngIf="titularForm.get('rut')?.touched && titularForm.get('rut')?.hasError('rutInvalido')">
                                        El RUT ingresado no es válido.
                                    </small>

                                    <small class="text-danger d-block"
                                        *ngIf="shouldShowTitularPlanValidationMessage()">
                                        {{ titularRutPlanValidationMessage }}
                                    </small>
                                </div>



                                <div class="form-group col-lg-12 col-xl-6">
                                    <label class="label-sm">Nombre*</label>

                                    <input type="text" class="form-control form-control-rounded" placeholder="Nombre"
                                        formControlName="nombre" (keypress)="allowOnlyLetters($event)">

                                    <small class="text-danger d-block mt-1"
                                        *ngIf="titularForm.get('nombre')?.touched && titularForm.get('nombre')?.hasError('required')">
                                        El nombre es obligatorio.
                                    </small>

                                    <small class="text-danger d-block mt-1"
                                        *ngIf="titularForm.get('nombre')?.touched && titularForm.get('nombre')?.hasError('minlength')">
                                        El nombre debe tener al menos 2 caracteres.
                                    </small>
                                </div>

                                <div class="form-group col-lg-12 col-xl-6">
                                    <label class="label-sm">Primer apellido*</label>

                                    <input type="text" class="form-control form-control-rounded"
                                        placeholder="Primer apellido" formControlName="primerApellido"
                                        (keypress)="allowOnlyLetters($event)">

                                    <small class="text-danger d-block mt-1"
                                        *ngIf="titularForm.get('primerApellido')?.touched && titularForm.get('primerApellido')?.hasError('required')">
                                        El primer apellido es obligatorio.
                                    </small>

                                    <small class="text-danger d-block mt-1"
                                        *ngIf="titularForm.get('primerApellido')?.touched && titularForm.get('primerApellido')?.hasError('minlength')">
                                        El primer apellido debe tener al menos 2 caracteres.
                                    </small>
                                </div>

                                <div class="form-group col-lg-12 col-xl-6">
                                    <label class="label-sm">Segundo apellido</label>

                                    <input type="text" class="form-control form-control-rounded"
                                        placeholder="Segundo apellido" formControlName="segundoApellido"
                                        (keypress)="allowOnlyLetters($event)">
                                </div>

                                <div class="form-group col-lg-12 col-xl-6">
                                    <label class="label-sm">Fecha de nacimiento*</label>

                                    <input type="date" class="form-control form-control-rounded"
                                        formControlName="fechaNacimiento" [attr.max]="todayDate">

                                    <small class="text-danger d-block mt-1"
                                        *ngIf="titularForm.get('fechaNacimiento')?.touched && titularForm.get('fechaNacimiento')?.hasError('required')">
                                        La fecha de nacimiento es obligatoria.
                                    </small>

                                    <small class="text-danger d-block mt-1"
                                        *ngIf="titularForm.get('fechaNacimiento')?.touched && titularForm.get('fechaNacimiento')?.hasError('fechaMayorActual')">
                                        La fecha de nacimiento no puede ser mayor a la fecha actual.
                                    </small>
                                </div>

                            </div>
                            <div class="form-row">

                                <div class="form-group col-lg-12 col-xl-6">
                                    <label class="label-sm">Email*</label>

                                    <input type="email" class="form-control form-control-rounded"
                                        placeholder="ejemplo@correo.cl" formControlName="email">

                                    <small class="text-danger d-block mt-1"
                                        *ngIf="titularForm.get('email')?.touched && titularForm.get('email')?.hasError('required')">
                                        El email es obligatorio.
                                    </small>

                                    <small class="text-danger"
                                        *ngIf="titularForm.get('email')?.touched && titularForm.get('email')?.hasError('emailFormatoInvalido')">
                                        El correo ingresado no tiene un formato válido.
                                    </small>
                                </div>

                                <div class="form-group col-lg-12 col-xl-6">

                                    <div class="form-row no-gutters">

                                        <div class="col-4 col-md-4 pr-2">
                                            <label class="label-sm">Código de Área</label>

                                            <div class="custom-select-flag" (click)="toggleFlagDropdown()"
                                                [class.open]="flagDropdownOpen">

                                                <div class="selected d-flex align-items-center justify-content-between">
                                                    <div class="d-flex align-items-center">
                                                        <span class="fi mr-2" [ngClass]="selectedAreaCode?.cou_flag"
                                                            style="font-size: 10px;">
                                                        </span>

                                                        (+{{ selectedAreaCode?.cou_phone_code }})
                                                    </div>

                                                    <i class="fi fi-rr-angle-small-down"></i>
                                                </div>

                                                <div class="options" *ngIf="flagDropdownOpen">
                                                    <div class="option" *ngFor="let areaCode of areaCodes"
                                                        (click)="selectAreaCode(areaCode); $event.stopPropagation();">

                                                        <span class="fi mr-2" [ngClass]="areaCode.cou_flag"></span>
                                                        (+{{ areaCode.cou_phone_code }})
                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                        <div class="col col-md-8">
                                            <label class="label-sm">Teléfono*</label>

                                            <input type="tel" class="form-control form-control-rounded"
                                                placeholder="Teléfono" formControlName="telefono"
                                                (input)="onTelefonoInput($event)" (keypress)="allowOnlyNumbers($event)"
                                                [attr.minlength]="selectedAreaCode?.cou_min_phone"
                                                [attr.maxlength]="selectedAreaCode?.cou_max_phone || 15">

                                            <small class="text-danger d-block mt-1"
                                                *ngIf="titularForm.get('telefono')?.touched && titularForm.get('telefono')?.hasError('required')">
                                                El teléfono es obligatorio.
                                            </small>

                                            <small class="text-muted d-block m-0" *ngIf="selectedAreaCode">
                                                Ingrese número entre {{ selectedAreaCode?.cou_min_phone }} y
                                                {{ selectedAreaCode?.cou_max_phone }} dígitos.
                                            </small>

                                            <small class="text-info d-block mt-1" *ngIf="shouldShowTelefonoMissingMessage()">
                                                {{ getTelefonoRemainingMessage() }}
                                            </small>
                                        </div>

                                    </div>
                                </div>

                                <div class="form-footer col-12">
                                    <div
                                        class="d-flex justify-content-between align-items-center footer-actions step2-form-actions">

                                        <button type="button" class="btn btn-light btn-pill" (click)="prevStep()">
                                            <i class="fi fi-rr-arrow-left mr-2"></i>

                                            Volver
                                        </button>

                                        <button type="button" class="btn btn-secondary btn-pill"
                                            [disabled]="!isStep2Valid() || checkingTitularPlanExist" (click)="nextFromStep2()">
                                            Continuar
                                            <i class="fi fi-rr-arrow-right ml-2"></i>
                                        </button>

                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>

                    <!-- STEP 3 -->
                    <div *ngIf="steps.beneficiarios">

                        <div class="form-content px-4 py-3" [formGroup]="beneficiariosDecisionForm">

                            <h3 class="m-0 title-step">Beneficiarios</h3>
                            <h5 class="m-0 sub-title-step">
                                Selecciona la cantidad de cargas que tendrá el plan y completa solo los datos que tengas disponibles.
                            </h5>
                            <br>

                            <div class="step2-plan-summary-card" *ngIf="getPlanSeleccionado()">
                                <div class="step2-plan-top">
                                    <div>
                                        <span>Plan seleccionado</span>
                                        <strong>{{ getPlanSeleccionado()?.cus_ben_name }}</strong>
                                    </div>

                                    <button type="button" class="step2-change-plan-btn" (click)="goToStep1()">
                                        <i class="fi fi-rr-edit"></i>
                                        Cambiar plan
                                    </button>
                                </div>

                                <div class="step2-price-main">
                                    <span>Valor Total Mensual</span>
                                    <strong>{{ formatPrecioPlan(getTotalPlanMensual()) }}</strong>
                                </div>

                                <button type="button" class="step2-detail-toggle"
                                    (click)="toggleDetallePrecioTitular()">
                                    {{ mostrarDetallePrecioTitular ? 'Ocultar detalle del precio' : 'Ver detalle del precio' }}
                                    <i class="fi"
                                        [ngClass]="mostrarDetallePrecioTitular ? 'fi-rr-angle-small-up' : 'fi-rr-angle-small-down'">
                                    </i>
                                </button>

                                <div class="step2-price-detail" *ngIf="mostrarDetallePrecioTitular">
                                    <div class="step2-price-detail-row" *ngFor="let item of getDetallePrecioTitular()">
                                        <span>{{ item.label }}</span>
                                        <strong>{{ formatPrecioPlan(item.amount) }}</strong>
                                    </div>

                                    <div class="step2-price-detail-row step2-price-detail-total">
                                        <span>Total</span>
                                        <strong>{{ formatPrecioPlan(getTotalPlanMensual()) }}</strong>
                                    </div>
                                </div>
                            </div>

                            <div class="beneficiarios-step-card">
                                <div class="beneficiarios-question-title">
                                    ¿Quieres agregar beneficiarios?
                                </div>

                                <div class="beneficiarios-choice-group">
                                    <button type="button" class="beneficiarios-choice-btn"
                                        [ngClass]="{ 'active': getDeseaAgregarBeneficiarios() === 'SI' }"
                                        (click)="seleccionarDeseaAgregarBeneficiarios('SI')">
                                        Sí
                                    </button>

                                    <button type="button" class="beneficiarios-choice-btn"
                                        [ngClass]="{ 'active': getDeseaAgregarBeneficiarios() === 'NO' }"
                                        (click)="seleccionarDeseaAgregarBeneficiarios('NO')">
                                        No
                                    </button>
                                </div>
                            </div>

                            <div class="beneficiarios-info-banner mt-3" *ngIf="getDeseaAgregarBeneficiarios() === 'NO'">
                                <div class="beneficiarios-info-banner-top">
                                    <i class="fi fi-rr-info"></i>
                                    <span>
                                        El paciente podrá agregar beneficiarios posteriormente desde su perfil de la plataforma.
                                    </span>
                                </div>

                                <div class="beneficiarios-info-route">
                                    <span>Mi perfil</span>
                                    <span class="route-separator">›</span>
                                    <span>Mis planes y convenios</span>
                                    <span class="route-separator">›</span>
                                    <span>Detalle del plan</span>
                                    <span class="route-separator">›</span>
                                    <strong>Modificar beneficiarios</strong>
                                </div>
                            </div>

                            <ng-container *ngIf="getDeseaAgregarBeneficiarios() === 'SI'">

                                <div class="beneficiarios-step-card mt-3">
                                    <div class="beneficiarios-question-title">
                                        ¿Cuántos beneficiarios quieres agregar al plan?
                                    </div>

                                    <div class="beneficiarios-count-grid">
                                        <button type="button" class="beneficiarios-count-btn"
                                            *ngFor="let cantidad of cantidadBeneficiariosOpciones"
                                            [ngClass]="{ 'active': getCantidadBeneficiariosDespuesSeleccionada() === cantidad }"
                                            (click)="seleccionarCantidadBeneficiariosDespues(cantidad)">
                                            {{ cantidad }}
                                        </button>
                                    </div>

                                    <small class="text-danger d-block mt-2"
                                        *ngIf="beneficiariosDecisionForm.touched && !getCantidadBeneficiariosDespuesSeleccionada()">
                                        Debes indicar cuántos beneficiarios deseas agregar.
                                    </small>
                                </div>

                                <div class="beneficiarios-info-banner mt-3"
                                    *ngIf="getCantidadBeneficiariosDespuesSeleccionada()">
                                    <div class="beneficiarios-info-banner-top">
                                        <i class="fi fi-rr-info"></i>
                                        <span>
                                            Se generarán {{ getCantidadBeneficiariosDespuesSeleccionada() }}
                                            espacio(s) para beneficiarios. Puedes completar uno, varios o todos ahora.
                                            El carro de compra considerará la cantidad total seleccionada.
                                        </span>
                                    </div>
                                </div>

                            </ng-container>

                            <div class="beneficiarios-form-wrapper mt-3" *ngIf="isBeneficiariosAhoraFlow()">

                                <div class="beneficiarios-section-header">
                                    <div>
                                        <h5 class="title-step mb-1">Cargas / Beneficiarios</h5>
                                        <p class="beneficiarios-section-help mb-0">
                                            Completa solo los espacios que tengas disponibles. Los espacios pendientes quedarán sin datos,
                                            pero se enviará igualmente la cantidad total seleccionada al carro de compra.
                                        </p>
                                    </div>

                                    <div class="beneficiarios-slots-counter">
                                        {{ getBeneficiariosCompletadosCount() }} / {{ getCantidadBeneficiariosActual() }}
                                        completado(s)
                                    </div>
                                </div>

                                <div class="beneficiarios-slots-list mt-3">

                                    <div class="beneficiario-slot-item"
                                        *ngFor="let beneficiario of beneficiarios.controls; let i = index"
                                        [ngClass]="{ 'completed': isBeneficiarioSlotCompleto(i), 'pending': !isBeneficiarioSlotCompleto(i) }">

                                        <div class="beneficiario-info">

                                            <div class="avatar-icon"
                                                [ngClass]="{ 'pending': !isBeneficiarioSlotCompleto(i) }">
                                                <i class="fi"
                                                    [ngClass]="isBeneficiarioSlotCompleto(i) ? 'fi-rr-user' : 'fi-rr-user-add'">
                                                </i>
                                            </div>

                                            <div>
                                                <div class="beneficiario-slot-title">
                                                    {{ getBeneficiarioSlotTitulo(i) }}
                                                </div>

                                                <ng-container *ngIf="isBeneficiarioSlotCompleto(i); else beneficiarioPendiente">
                                                    <div class="beneficiario-name">
                                                        {{ beneficiario.value.nombre }}
                                                        {{ beneficiario.value.primerApellido }}
                                                        {{ beneficiario.value.segundoApellido }}
                                                    </div>

                                                    <div class="beneficiario-rut">
                                                        RUT: {{ beneficiario.value.rut }}
                                                    </div>

                                                    <div class="beneficiario-rut" *ngIf="beneficiario.value.email">
                                                        Email: {{ beneficiario.value.email }}
                                                    </div>
                                                </ng-container>

                                                <ng-template #beneficiarioPendiente>
                                                    <div class="beneficiario-slot-pending-text">
                                                        Espacio pendiente de completar
                                                    </div>
                                                </ng-template>
                                            </div>

                                        </div>

                                        <div class="beneficiario-actions">

                                            <button type="button" class="btn-beneficiario-action edit"
                                                *ngIf="isBeneficiarioSlotCompleto(i)"
                                                (click)="editarBeneficiario(i)">
                                                <i class="fi fi-rr-pencil"></i>
                                                Editar
                                            </button>

                                            <button type="button" class="btn-beneficiario-action delete"
                                                *ngIf="isBeneficiarioSlotCompleto(i)"
                                                (click)="eliminarBeneficiario(i)">
                                                <i class="fi fi-rr-trash"></i>
                                                Eliminar datos
                                            </button>

                                            <button type="button" class="btn-beneficiario-slot-add"
                                                *ngIf="!isBeneficiarioSlotCompleto(i)"
                                                (click)="abrirModalAgregarBeneficiario(i)">
                                                <i class="fi fi-rr-plus mr-2"></i>
                                                Agregar beneficiario
                                            </button>

                                        </div>

                                    </div>

                                </div>

                            </div>

                            <small class="text-danger d-block mt-2"
                                *ngIf="beneficiariosDecisionForm.touched && !getDeseaAgregarBeneficiarios()">
                                Debes indicar si deseas agregar beneficiarios.
                            </small>

                            <div class="form-footer col-12 mt-3 px-0">
                                <div class="d-flex justify-content-between align-items-center footer-actions">
                                    <button type="button" class="btn btn-light btn-pill" (click)="prevStep()">
                                        <i class="fi fi-rr-arrow-left mr-2"></i>
                                        Volver
                                    </button>

                                    <button type="button" class="btn btn-secondary btn-pill"
                                        [disabled]="!isBeneficiariosStepValid()"
                                        (click)="nextFromStep3()">
                                        Continuar
                                        <i class="fi fi-rr-arrow-right ml-2"></i>
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>

                    <!-- STEP 4 -->
                    <div *ngIf="steps.resumenEnvio">
                        <div class="form-content px-4 py-3">
                            <h3 class="m-0 title-step">Revisión y validación de inscripción</h3>
                            <h5 class="m-0 sub-title-step review-subtitle">
                                Revisa los datos del paciente, valida el plan seleccionado y confirma la información antes de<br class="d-none d-md-block">
                                enviar el proceso al paciente para que continúe con los pasos finales.
                            </h5>
                            <br>

                            <div class="review-section-title">1. Resumen de inscripción</div>

                            <div class="review-plan-card" *ngIf="getPlanSeleccionado()">
                                <div class="review-plan-header">
                                    <div class="review-plan-main">
                                        <div class="review-plan-icon">
                                            <i class="fi fi-rr-heart"></i>
                                        </div>

                                        <div>
                                            <h4>{{ getPlanSeleccionado()?.cus_ben_name || 'Plan contratado' }}</h4>
                                            <p>
                                                Titular + {{ getCantidadBeneficiariosActual() }}
                                                {{ getCantidadBeneficiariosActual() === 1 ? 'beneficiario' : 'beneficiarios' }}
                                            </p>
                                        </div>
                                    </div>

                                    <div class="review-plan-price">
                                        <span>Precio mensual</span>
                                        <strong>{{ formatPrecioPlan(getTotalPlanMensual()) }}</strong>
                                    </div>
                                </div>

                                <div class="review-info-grid">
                                    <div class="review-info-item">
                                        <i class="fi fi-rr-building"></i>
                                        <span>Cliente asociado</span>
                                        <strong>{{ getNombreConvenio() }}</strong>
                                    </div>

                                    <div class="review-info-item">
                                        <i class="fi fi-rr-user"></i>
                                        <span>Tipo de plan</span>
                                        <strong>{{ getPlanSeleccionado()?.cus_ben_particular ? 'Particular' : 'Convenio' }}</strong>
                                    </div>

                                    <div class="review-info-item">
                                        <i class="fi fi-rr-calendar"></i>
                                        <span>Fecha de inicio de vigencia</span>
                                        <strong>{{ formatFechaPlan(getFechaInicioVigenciaPlan()) }}</strong>
                                    </div>

                                    <div class="review-info-item">
                                        <i class="fi fi-rr-calendar-clock"></i>
                                        <span>Fecha término de vigencia</span>
                                        <strong>
                                            {{
                                                formatFechaPlan(
                                                    getFechaRenovacionAnualPlan(getPlanSeleccionado())
                                                )
                                            }}
                                        </strong>
                                    </div>
                                </div>

                                <div class="review-content-grid">
                                    <div class="plan-terms-specialties-box">

                                        <h5>Especialidades y cantidad de consultas del plan</h5>

                                        <div
                                            class="plan-terms-specialty-table"
                                            *ngIf="getEspecialidadesPlanSeleccionado().length > 0">

                                            <!-- ENCABEZADO -->
                                            <div
                                                class="plan-terms-specialty-head"
                                                [style.grid-template-columns]="
                                                    tieneBeneficiariosSeleccionados()
                                                        ? 'minmax(0, 1fr) 110px 110px'
                                                        : 'minmax(0, 1fr) 110px'
                                                ">

                                                <span>Especialidad</span>

                                                <span>Titular</span>

                                                <span *ngIf="tieneBeneficiariosSeleccionados()">
                                                    Beneficiario
                                                </span>

                                            </div>

                                            <!-- ESPECIALIDADES -->
                                            <div
                                                class="plan-terms-specialty-row"
                                                *ngFor="let especialidad of getEspecialidadesPlanSeleccionado()"
                                                [style.grid-template-columns]="
                                                    tieneBeneficiariosSeleccionados()
                                                        ? 'minmax(0, 1fr) 110px 110px'
                                                        : 'minmax(0, 1fr) 110px'
                                                ">

                                                <div class="plan-terms-specialty-name">
                                                    <i class="fi fi-rr-stethoscope"></i>

                                                    <span>
                                                        {{ especialidad.spe_name }}
                                                    </span>
                                                </div>

                                                <!-- CONSULTAS DEL TITULAR -->
                                                <strong>
                                                    {{
                                                        getTextoCantidadConsultas(
                                                            especialidad.cus_ben_qty_con_titular
                                                        )
                                                    }}
                                                </strong>

                                                <!-- CONSULTAS DEL BENEFICIARIO:
                                                     solo se muestran cuando se seleccionó
                                                     al menos un beneficiario en el Step 3 -->
                                                <strong *ngIf="tieneBeneficiariosSeleccionados()">
                                                    {{
                                                        getTextoCantidadConsultas(
                                                            especialidad.cus_ben_qty_con_beneficiaries
                                                        )
                                                    }}
                                                </strong>

                                            </div>

                                        </div>

                                        <div
                                            class="plan-terms-empty-specialties"
                                            *ngIf="getEspecialidadesPlanSeleccionado().length === 0">

                                            No hay especialidades configuradas para este plan.

                                        </div>

                                        <div class="plan-terms-specialty-note">

                                            <i class="fi fi-rr-info"></i>

                                            <span *ngIf="tieneBeneficiariosSeleccionados()">
                                                Cantidad de consultas disponibles anuales por titular o beneficiario.
                                            </span>

                                            <span *ngIf="!tieneBeneficiariosSeleccionados()">
                                                Cantidad de consultas disponibles anuales para el titular.
                                            </span>

                                        </div>

                                    </div>

                                    <div class="plan-terms-conditions-box">

                                        <h5>Consideraciones del plan</h5>

                                        <p>
                                            {{ getPlanSeleccionado()?.cus_ben_text_consideraciones }}
                                        </p>

                                        <p *ngIf="getPlanSeleccionado()?.cus_ben_description">
                                            {{ getPlanSeleccionado()?.cus_ben_description }}
                                        </p>

                                    </div>
                                </div>
                            </div>

                            <div class="executive-validation-box" [formGroup]="validacionEjecutivoForm">
                                <div class="review-section-title mb-2">2. Validación del ejecutivo</div>

                                <div class="executive-validation-alert">
                                    <i class="fi fi-rr-info"></i>
                                    <span>
                                        Al confirmar esta información, se enviará un correo al paciente con un enlace para continuar el proceso desde la informacion del plan seleccionado.
                                    </span>
                                </div>

                                <label class="executive-validation-check">
                                    <input
                                        type="checkbox"
                                        class="executive-validation-checkbox"
                                        formControlName="aceptaRevision">

                                    <span class="executive-validation-text">
                                        He revisado y validado los datos del paciente y el plan seleccionado.
                                    </span>
                                </label>

                                <small class="text-danger d-block mt-1" *ngIf="validacionEjecutivoForm.get('aceptaRevision')?.touched && validacionEjecutivoForm.get('aceptaRevision')?.invalid">
                                    Debes confirmar la validación para enviar la solicitud al paciente.
                                </small>
                            </div>

                            <div class="form-footer col-12 mt-3 px-0">
                                <div class="d-flex justify-content-between align-items-center footer-actions">
                                    <button type="button" class="btn btn-light btn-pill" (click)="prevStep()">
                                        <i class="fi fi-rr-arrow-left mr-2"></i>
                                        Volver
                                    </button>

                                    <button type="button"
                                        class="btn btn-secondary btn-pill"
                                        [disabled]="!isStep4Valid() || creatingCartSubscription || loadingSubmit || sendingMailPaciente"
                                        (click)="nextFromStep4()">

                                        <span *ngIf="creatingCartSubscription || loadingSubmit || sendingMailPaciente" class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>

                                        {{ creatingCartSubscription || loadingSubmit || sendingMailPaciente ? 'Enviando...' : 'Enviar al paciente' }}
                                        <i *ngIf="!creatingCartSubscription && !loadingSubmit && !sendingMailPaciente" class="fi fi-rr-arrow-right ml-2"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <!-- PANTALLA FINAL EJECUTIVO -->
        <div class="row mt-xl-3 mx-0 justify-content-center" *ngIf="convenioDisponible && showSuccessExecutiveScreen">
            <div class="col-12 p-0 d-flex justify-content-center">
                <div class="card executive-success-card">
                    <div class="executive-success-icon">
                        <i class="fi fi-rr-check"></i>
                    </div>

                    <h1 class="executive-success-title">¡Proceso finalizado con éxito!</h1>

                    <p class="executive-success-subtitle">
                        La primera parte del proceso ha sido completada correctamente.
                    </p>

                    <p class="executive-success-message">
                        Hemos enviado un correo al titular con un enlace para continuar el proceso<br class="d-none d-md-block">
                        de inscripción desde el detalle del plan a contratar y la inscripción del pago.
                    </p>

                    <div class="executive-success-info-box">
                        <div class="executive-success-info-title">
                            <i class="fi fi-rr-info"></i>
                            <span>El titular deberá completar los siguientes pasos desde el enlace enviado por correo:</span>
                        </div>

                        <ul>
                            <li>Validación de datos de la inscripción</li>
                            <li>Aceptar términos y condiciones</li>
                            <li>Inscripción del pago</li>
                        </ul>
                    </div>

                    <div class="executive-success-actions">
                        <button type="button" class="btn btn-light btn-pill executive-success-btn" (click)="irAlInicio()">
                            <i class="fi fi-rr-arrow-left mr-2"></i>
                            Volver al inicio
                        </button>

                        <button type="button" class="btn btn-secondary btn-pill executive-success-btn" (click)="registrarOtroPaciente()">
                            Registrar otro paciente
                            <i class="fi fi-rr-arrow-right ml-2"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- FOOTER AYUDA -->
        <div class="help-footer">
            <i class="fi fi-rr-headset"></i>

            <span>¿Necesitas ayuda? Contáctanos en</span>

            <a href="mailto:soporte@almamedis.cl">
                soporte@almamedis.cl
            </a>
        </div>
    </ng-container>

    <!-- MODAL BENEFICIARIO -->
    <div class="modal fade show d-block" tabindex="-1" role="dialog"
        style="background: rgba(0,0,0,.5);" *ngIf="mostrarModalBeneficiario">

        <div class="modal-dialog" role="document">

            <div class="modal-content" [formGroup]="beneficiarioForm">

                <div class="modal-header">

                    <h3 class="title-step m-0">
                        {{ indexBeneficiarioEditando !== null ? 'Editar beneficiario' : 'Agregar beneficiario' }}
                    </h3>

                    <button type="button" class="close" (click)="cerrarModalBeneficiario()">
                        <span aria-hidden="true">&times;</span>
                    </button>

                </div>

                <div class="modal-body">

                    <!-- RUT -->
                    <div class="form-group">

                        <label class="label-sm">RUT beneficiario*</label>

                        <input type="text"
                            class="form-control form-control-rounded"
                            placeholder="Ej: 12.345.678-9"
                            formControlName="rut"
                            (blur)="onBeneficiarioRutBlur()"
                            (keypress)="allowOnlyRutChars($event)">

                        <small class="text-danger d-block"
                            *ngIf="beneficiarioForm.get('rut')?.touched && beneficiarioForm.get('rut')?.hasError('required')">
                            El RUT del beneficiario es obligatorio.
                        </small>

                        <small class="text-danger d-block"
                            *ngIf="beneficiarioForm.get('rut')?.touched && beneficiarioForm.get('rut')?.hasError('rutInvalido')">
                            El RUT ingresado no es válido.
                        </small>

                        <small class="text-danger d-block"
                            *ngIf="beneficiarioForm.get('rut')?.touched && beneficiarioForm.get('rut')?.hasError('rutIgualTitular')">
                            El beneficiario no puede tener el mismo RUT del titular.
                        </small>

                        <small class="text-danger d-block"
                            *ngIf="beneficiarioForm.get('rut')?.touched && beneficiarioForm.get('rut')?.hasError('rutBeneficiarioDuplicado')">
                            Este RUT ya fue ingresado como beneficiario en este plan.
                        </small>

                    </div>

                    <!-- NOMBRE -->
                    <div class="form-group">

                        <label class="label-sm">Nombre*</label>

                        <input type="text"
                            class="form-control form-control-rounded"
                            placeholder="Nombre"
                            formControlName="nombre"
                            (keypress)="allowOnlyLetters($event)">

                        <small class="text-danger d-block"
                            *ngIf="beneficiarioForm.get('nombre')?.touched && beneficiarioForm.get('nombre')?.hasError('required')">
                            El nombre es obligatorio.
                        </small>

                        <small class="text-danger d-block"
                            *ngIf="beneficiarioForm.get('nombre')?.touched && beneficiarioForm.get('nombre')?.hasError('minlength')">
                            El nombre debe tener al menos 2 caracteres.
                        </small>

                    </div>

                    <!-- PRIMER APELLIDO -->
                    <div class="form-group">

                        <label class="label-sm">Primer apellido*</label>

                        <input type="text"
                            class="form-control form-control-rounded"
                            placeholder="Primer apellido"
                            formControlName="primerApellido"
                            (keypress)="allowOnlyLetters($event)">

                        <small class="text-danger d-block"
                            *ngIf="beneficiarioForm.get('primerApellido')?.touched && beneficiarioForm.get('primerApellido')?.hasError('required')">
                            El primer apellido es obligatorio.
                        </small>

                        <small class="text-danger d-block"
                            *ngIf="beneficiarioForm.get('primerApellido')?.touched && beneficiarioForm.get('primerApellido')?.hasError('minlength')">
                            El primer apellido debe tener al menos 2 caracteres.
                        </small>

                    </div>

                    <!-- SEGUNDO APELLIDO -->
                    <div class="form-group">

                        <label class="label-sm">Segundo apellido</label>

                        <input type="text"
                            class="form-control form-control-rounded"
                            placeholder="Segundo apellido"
                            formControlName="segundoApellido"
                            (keypress)="allowOnlyLetters($event)">

                    </div>

                    <!-- FECHA DE NACIMIENTO -->
                    <div class="form-group">

                        <label class="label-sm">Fecha de nacimiento*</label>

                        <input type="date"
                            class="form-control form-control-rounded"
                            formControlName="fechaNacimiento"
                            [attr.max]="todayDate">

                        <small class="text-danger d-block"
                            *ngIf="beneficiarioForm.get('fechaNacimiento')?.touched && beneficiarioForm.get('fechaNacimiento')?.hasError('required')">
                            La fecha de nacimiento es obligatoria.
                        </small>

                        <small class="text-danger d-block"
                            *ngIf="beneficiarioForm.get('fechaNacimiento')?.touched && beneficiarioForm.get('fechaNacimiento')?.hasError('fechaMayorActual')">
                            La fecha de nacimiento no puede ser mayor a la fecha actual.
                        </small>

                        <small class="text-danger d-block"
                            *ngIf="beneficiarioForm.get('fechaNacimiento')?.touched && beneficiarioForm.get('fechaNacimiento')?.hasError('fechaInvalida')">
                            La fecha de nacimiento ingresada no es válida.
                        </small>

                    </div>

                    <!-- EMAIL -->
                    <div class="form-group">

                        <label class="label-sm">Email beneficiario*</label>

                        <input type="email"
                            class="form-control form-control-rounded"
                            placeholder="correo@ejemplo.cl"
                            formControlName="email">

                        <small class="text-danger d-block"
                            *ngIf="beneficiarioForm.get('email')?.touched && beneficiarioForm.get('email')?.hasError('required')">
                            El correo electrónico es obligatorio.
                        </small>

                        <small class="text-danger d-block"
                            *ngIf="beneficiarioForm.get('email')?.touched && beneficiarioForm.get('email')?.hasError('emailFormatoInvalido')">
                            El correo ingresado no tiene un formato válido.
                        </small>

                    </div>

                </div>

                <div class="modal-footer">

                    <button type="button"
                        class="btn btn-light btn-pill"
                        (click)="cerrarModalBeneficiario()">
                        Cancelar
                    </button>

                    <button type="button"
                        class="btn btn-secondary btn-pill"
                        (click)="guardarBeneficiario()">
                        {{ indexBeneficiarioEditando !== null ? 'Guardar cambios' : 'Guardar beneficiario' }}
                    </button>

                </div>

            </div>

        </div>

    </div>

    <!-- MODAL LIMPIAR -->
    <div class="modal fade show d-block" tabindex="-1" role="dialog" style="background: rgba(0,0,0,.5);" *ngIf="mostrarModalLimpiar">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">¿Limpiar formulario?</h5>
                    <button type="button" class="close" (click)="cerrarModalLimpiar()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="modal-body text-center">
                    <div class="mb-3">
                        <i class="fi fi-rr-triangle-warning" style="font-size:42px;color:#f59e0b;"></i>
                    </div>

                    <p class="mb-0">
                        Al limpiar el formulario se eliminarán los datos ingresados junto con los beneficiarios agregados.
                        <br>
                        ¿Deseas continuar?
                    </p>
                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-light btn-pill" (click)="cerrarModalLimpiar()">
                        Cancelar
                    </button>

                    <button type="button" class="btn btn-secondary btn-pill" (click)="limpiarFormulario()">
                        Limpiar
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>